import React from "react";

// Helper to underline and bold only the <u>...</u> part in the question string
function renderQuestionWithUnderline(question) {
  return {
    __html: question.replace(/（\s*）|\(\s*\)/, '<span style="font-weight:bold;">（　）</span>')
  };
}

const N5MojiGoiQ3 = ({
  questions,
  selectedAnswers,
  showResult,
  handleAnswerChange,
}) => {
  if (!questions) return null;

  return (
    <div>
      <div style={{ fontSize: "1.2rem", marginBottom: "0.5rem", fontWeight: 'bold' }}>
        もんだい3 <b>( )</b>に なにを いれますか。 1・2・3・4から いちばん いい ものを ひとつ えらんでください。

      </div>

      <ul style={{ listStyle: 'none', padding: 0 }}>
        {questions.map((item, idx) => (
          <li
            key={item.id}
            style={{
              marginBottom: '2.5rem',
              width: '100%',
              background: '#f8faff',
              borderRadius: '12px',
              boxShadow: '0 2px 8px rgba(25,118,210,0.07)',
              padding: '1.2rem'
            }}
          >
            <div style={{ marginBottom: '1rem', fontSize: '1.2rem', fontWeight: 500 }}>
              <span style={{ marginRight: 12 }}>{idx + 13}.</span>
              <span dangerouslySetInnerHTML={renderQuestionWithUnderline(item.question)} />
            </div>

            {item.answers?.length === 4 && (
              <div
                style={{
                  display: 'flex',
                  flexWrap: 'wrap',
                  gap: '1rem',
                  justifyContent: 'center'
                }}
              >
                {item.answers.map((ans, ansIdx) => {
                  const isSelected = selectedAnswers[item.id] === ansIdx;
                  let color;
                  if (showResult) {
                    if (ansIdx === item.correct) color = 'green';
                    else if (isSelected) color = 'red';
                  }

                  return (
                    <label
                      key={ansIdx}
                      style={{
                        flex: '1 1 180px',
                        display: 'flex',
                        alignItems: 'center',
                        padding: '0.8rem 1rem',
                        borderRadius: '6px',
                        border: '1px solid #ddd',
                        background: '#fff',
                        cursor: showResult ? 'default' : 'pointer',
                        fontSize: '1.1rem',
                        fontWeight: isSelected ? 700 : 500,
                        textDecoration: isSelected ? 'underline' : 'none',
                        color: color,
                        transition: 'all 0.2s ease'
                      }}
                    >
                      <input
                        type="radio"
                        name={`question-${item.id}`}
                        value={ansIdx}
                        checked={isSelected}
                        onChange={() => handleAnswerChange(item.id, ansIdx)}
                        disabled={showResult}
                        style={{
                          marginRight: 12,
                          accentColor: "#1976d2",
                          width: 20,
                          height: 20
                        }}
                      />
                      {ans}
                      {showResult && ansIdx === item.correct && (
                        <span style={{ marginLeft: 10, fontWeight: 'bold', color: 'green' }}>✓</span>
                      )}
                      {showResult && isSelected && ansIdx !== item.correct && (
                        <span style={{ marginLeft: 10, fontWeight: 'bold', color: 'red' }}>✗</span>
                      )}
                    </label>
                  );
                })}
              </div>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default N5MojiGoiQ3;
